const bookingPastDueReducer = (state = false, action) => {
	switch(action.type){
	case 'ISPASTDUE':	
		return true;
	default:
		return state;
	}
}

export default bookingPastDueReducer;